import { render } from "./TwoFaResetSuccess.vue?vue&type=template&id=661d3c36&scoped=true"
import script from "./TwoFaResetSuccess.vue?vue&type=script&lang=js"
export * from "./TwoFaResetSuccess.vue?vue&type=script&lang=js"

import "./TwoFaResetSuccess.vue?vue&type=style&index=0&id=661d3c36&scoped=true&lang=css"

import exportComponent from "/data/vstsagent02/user/3807/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661d3c36"]])

export default __exports__